export default class FormLogoAnimation {
    static init(): void {
        const vectorImg = document.getElementById('form-vector-icon');
        const baseForm = document.querySelector('.base-form');

        if (!vectorImg || !baseForm) return;

        vectorImg.style.transform = 'translate(-100px, 100px)';
        vectorImg.style.opacity = '0';
        vectorImg.style.transition = 'all 0.5s ease';

        const vectorAnimate = () => {
            vectorImg.style.transform = 'translate(0, 0)';
            vectorImg.style.opacity = '1';
        };

        const handleScroll = () => {
            const formTop = baseForm.getBoundingClientRect().top;
            const formHeight = baseForm.getBoundingClientRect().height;
            const scrollPercentage = ((window.innerHeight - formTop) / formHeight) * 100;

            if (scrollPercentage >= 30) {
                vectorAnimate();
                window.removeEventListener('scroll', handleScroll);
            }
        };

        window.addEventListener('scroll', handleScroll);
    }
}
